// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"534":"c5bdc408","587":"89b9f4a9","695":"ba909fb3"}[chunkId] + ".chunk.css";
};